import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { setTourStatus } from 'onboarding-tours-client/onboardingToursClient';
import { useContext, useState } from 'react';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import { NEW_USER_ONBOARDING_TOUR_NAME } from '../config/NewUserOnboardingTourConfig';
import { TourCompletionStatus } from 'onboarding-tours-client/constants';
import Raven from 'raven-js';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TourStepWithProgress = props => {
  const tourContext = useContext(TourContext);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showFinishDialog, setShowFinishDialog] = useState(false);
  const steps = tourContext.tour.getConfig().steps;
  const currentStep = tourContext.tour.getStep();
  const stepCount = steps.indexOf(currentStep) + 1;
  const handleFinishTour = () => {
    tourContext.tour.finish();
    setTourStatus(NEW_USER_ONBOARDING_TOUR_NAME, TourCompletionStatus.COMPLETE).catch(e => {
      Raven.captureMessage('Failed to set tour status', {
        extra: {
          status: TourCompletionStatus.COMPLETE,
          tourName: NEW_USER_ONBOARDING_TOUR_NAME,
          error: e
        }
      });
    });
  };
  if (showCancelDialog) {
    return /*#__PURE__*/_jsx(ConfirmModal, {
      onConfirm: () => {
        setShowCancelDialog(false);
        handleFinishTour();
      },
      onReject: () => {
        setShowCancelDialog(false);
      },
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.exitTourModal.title"
      }),
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.exitTourModal.confirmButton"
      }),
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.exitTourModal.rejectButton"
      }),
      width: 450
    });
  }
  if (showFinishDialog) {
    return /*#__PURE__*/_jsxs(Modal, {
      use: "conversational",
      width: 450,
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.completedModal.title"
          })
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        align: "center",
        paddingBlockStart: "600",
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: () => setShowFinishDialog(false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.completedModal.returnToKBButton"
          })
        })
      })]
    });
  }
  if (props.content && (props.content.header || props.content.body)) {
    const contentWithHeaderAndBody = props.content;
    return /*#__PURE__*/_jsx(UITourStep, Object.assign({}, props, {
      width: 350,
      showCloseButton: true,
      showSteps: true,
      pulser: true,
      onClickCloseButton: () => {
        setShowCancelDialog(true);
        // this makes it so the tour step doesn't call tour.deactivate
        return false;
      },
      content: Object.assign({}, contentWithHeaderAndBody, {
        footer: stepCount === steps.length ? /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: () => {
            handleFinishTour();
            setShowFinishDialog(true);
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.tours.finishButton"
          })
        }) : /*#__PURE__*/_jsx(UITourNextButton, {
          use: "primary",
          children: contentWithHeaderAndBody.footer
        })
      })
    }));
  }
  return /*#__PURE__*/_jsx(UITourStep, Object.assign({}, props));
};
export default TourStepWithProgress;